// @flow
import React from 'react'
import RaisedButton from 'material-ui/RaisedButton'

const EntryButton = () => {
    return <RaisedButton label="申し込みする" href="https://osh.connpass.com/event/48114/" primary={true}/>
};

export default EntryButton



/** WEBPACK FOOTER **
 ** ./src/2017/components/EntryButton.js
 **/